import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../utils/SEO";

export default function WesternSaharaJurisdiction() {

    return (
        <main className='main'>
            <SEO
                title="Western Sahara Offshore | Company Formation & Licensing "
                description="Set up offshore companies in Western Sahara with CRA licensing. 0% tax jurisdiction for banking, crypto, gaming, and financial services. "
                keywords="Western Sahara offshore, CRA licensing Western Sahara, offshore company formation, IBC Western Sahara, crypto license Western Sahara, gaming license offshore, financial services Western Sahara, offshore jurisdiction Africa "
                url="/western-sahara-jurisdiction"
            />
            <IntroSection
                title="Western Sahara Jurisdiction"
                subtitle="Offshore Business, Licensing & Company Formation in Western Sahara"
                description="Western Sahara, through its Capital Regulatory Authority (CRA), has emerged as a dynamic offshore jurisdiction for entrepreneurs, fintech innovators, and gaming operators. With cost-effective structures, 0% corporate tax, and flexible licensing, it is becoming a recognized hub for offshore companies seeking global expansion."
                badges={[
                    "Offshore IBCs",
                    "Banking & Brokerage",
                    "Gaming & Crypto",
                    "Insurance & Asset Management"
                ]}
                buttonText="Request a Western Sahara Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/jurisdictions/western-sahara-hero.png')}
                imageAlt="Western Sahara Offshore Jurisdiction"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Choose Western Sahara?"
                        blocks={[
                            {
                                items: [
                                    { text: "0% Corporate & Personal Income Tax on offshore activities." },
                                    { text: "Fast Incorporation – IBC setup in 2–5 business days." },
                                    { text: "Low/No Capital Requirements for most licenses." },
                                    { text: "Global Accessibility – recognized in the international gaming, brokerage, and offshore community." },
                                    { text: "Wide Range of Licenses – from gaming and forex to banking and insurance." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Company Formation in Western Sahara (IBC)"
                        subtitle='Western Sahara offers International Business Companies (IBCs):'
                        blocks={[
                            {
                                items: [
                                    { text: "100% foreign ownership allowed." },
                                    { text: "No local presence required." },
                                    { text: "Confidential shareholder/beneficial ownership." },
                                    { text: "Flexible use for trading, holding, fintech, and licensing." },
                                    { text: "Incorporation Timeline: 2–5 business days." },
                                ]
                            }
                        ]}

                    />

                    <WhySection
                        title="Licenses Available in Western Sahara"
                        blocks={[
                            {
                                items: [
                                    { title: "Gaming & iGaming License", text: "Fast, cost-efficient license suitable for online casinos, sportsbooks, and gaming platforms." },
                                    { title: "Brokerage & Forex License", text: "Flexible, no high capital requirements, suitable for startups and mid-tier brokers." },
                                    { title: "Banking License", text: "Class I & II licenses available. Allows international banking services, capital requirement from USD 3M+." },
                                    { title: "Crypto License", text: "Covers exchanges, wallets, and blockchain services with flexible compliance." },
                                    { title: "Insurance & Trust License", text: "Offshore solutions for risk management, trusts, and reinsurance." },
                                    { title: "Asset Management License", text: "Enables management of funds, private equity, and investment portfolios." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Benefits of Western Sahara Licenses"
                        blocks={[
                            {
                                items: [
                                    { text: "Entry-level costs compared to Tier-1 jurisdictions." },
                                    { text: "Quick approvals (4–8 weeks average)." },
                                    { text: "Flexible requirements (many licenses without strict capital)." },
                                    { text: "Asset protection and confidentiality." },
                                    { text: "Attractive for gaming, fintech, forex, and emerging businesses." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Application Process"
                        blocks={[
                            {
                                items: [
                                    { text: "Select Company Structure (usually IBC)." },
                                    { text: "Prepare Documentation (KYC, business plan, due diligence)." },
                                    { text: "Submit Application to CRA." },
                                    { text: "Regulator Review." },
                                    { text: "License Issuance." },
                                    { text: "Timeline: 1–2 months for most licenses." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Western Sahara at a Glance"
                        blocks={[
                            {
                                items: [
                                    { text: "Corporate Tax: 0% (offshore activities)." },
                                    { text: "Incorporation Time: 2–5 days for IBCs." },
                                    { text: "License Time: 1–2 months." },
                                    { text: "Capital Requirement: None for most licenses; banking requires USD 3M+." },
                                    { text: "Recognition: Growing reputation in iGaming and offshore business circles." }
                                ]
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Ready to establish your business in Western Sahara?"
                        description="Offshore Advisory provides end-to-end support for IBC incorporation, licensing, and banking solutions."
                        buttonText="Book a Free Consultation for Western Sahara Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is Western Sahara recognized for offshore licensing?",
        answer: "Yes, it is increasingly recognized in the gaming, brokerage, and offshore communities, especially for cost-efficient setups.",
    },
    {
        question: "Are licenses expensive?",
        answer: "No, Western Sahara licenses are among the most affordable worldwide.",
    },
    {
        question: "Do I need to travel?",
        answer: "No physical presence is required for IBC or license setup.",
    },
    {
        question: "Can Western Sahara licenses be used globally?",
        answer: "Yes, but like all offshore licenses, acceptance depends on banks, payment providers, and counterparties.",
    },
];
